import React from "react";
import {
    Wrapper,
    Title,
    BgWrapper,
} from './ShopByCategory.style'
import CategoryCard from "./ShopByCategoryCard/ShopByCategoryCard";
import t from '../../i18n/translate'
const ShopByCategory = (props) => {
    return (
        <>
            <Wrapper>
                <Title>{t(`shop_by_category_title`)}</Title>
                <BgWrapper>
                    {
                        props.cats.map((data, index) => {
                            return (
                                <div key={data.id}>
                                    <CategoryCard image={data.image_link} title={data.title} webLink={data.web_link} priority={index < 4} />
                                </div>)
                        })
                    }
                </BgWrapper>
            </Wrapper>

        </>
    )
}
export default ShopByCategory;
